import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";

interface Props {
  onOpenChange: () => void;
  onConfirm: () => void;
}

export function ConfirmSend({ onOpenChange, onConfirm }: Props) {
  return (
    <Dialog.Root open onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-lg dark:bg-brand-gray-900">
        <Dialog.Header className="space-y-2 relative">
          <Dialog.Title className="leading-5 text-brand-gray-800 dark:text-brand-gray-100 ">
            Send email users
          </Dialog.Title>
          <Dialog.Description className="text-brand-gray-700 dark:text-brand-gray-300">
            Are you sure you want to send this email to Numerous&apos; users?
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="mt-8">
          <Dialog.Close asChild>
            <Button type="button" variant="secondary">
              Abort
            </Button>
          </Dialog.Close>
          <Dialog.Close asChild>
            <Button onClick={onConfirm}>Confirm</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}
